export const prefixUtms = properties => {
  if (!properties || typeof properties !== 'object') {
    return;
  }

  return Object.keys(properties).reduce((a, c) => (a[`utm_${c}`] = properties[c], a), {})
}